import { z } from 'zod';

/** RFC 9457 Problem Details as the API sends them (apps/api common/errors/problem.ts). */
export const problemSchema = z.object({
  type: z.string().optional(),
  title: z.string().optional(),
  status: z.number().optional(),
  detail: z.string().optional(),
  code: z.string().optional(),
  request_id: z.string().optional(),
  /** Lockout (not sent by the API yet): when the account opens again. */
  retry_at: z.string().optional(),
  /** Wrong credentials (not sent by the API yet): attempts before the lockout. */
  attempts_left: z.number().optional(),
  errors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
  /** The owner's carrier limit (409 `carrier_limit`): when the next read of that carrier may go; null: stopped. */
  next_possible_at: z.string().nullable().optional(),
  /** A Dokless call failed (502 `dokless_*`, «Aggiorna dati»): Dokless's HTTP status, when it answered. */
  http_status: z.number().nullable().optional(),
});
export type Problem = z.infer<typeof problemSchema>;

/** An HTTP failure with the API's stable `code` (or `network` / `http_<status>` when there is none). */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    readonly problem: Problem = {},
  ) {
    super(problem.detail ?? problem.title ?? code);
    this.name = 'ApiError';
  }

  get isNetwork(): boolean {
    return this.status === 0;
  }
}

export const isApiError = (error: unknown, code?: string): error is ApiError =>
  error instanceof ApiError && (code === undefined || error.code === code);
